import http from './axios';

export interface RuleDto {
  id?: number;
  approveStatus?: string;
  cronExpression?: string;
  droolsRule?: string;
  jobConfig?: any;
  jobMode?: number;
  ruleCategoryId?: number;
  ruleCode?: string;
  ruleDataCode?: any;
  ruleDataType?: number;
  ruleDefinition?: any;
  ruleDescription?: string;
  ruleFirstLevel?: string;
  ruleLabel?: string;
  ruleName?: string;
  ruleOwnerDept?: string;
  ruleOwnerPlate?: string;
  ruleOwnerUid?: string;
  ruleOwnerName?: string;
  rulePriority?: number;
  ruleSecondLevel?: string;
  ruleSetCode?: string;
  ruleSort?: number;
  ruleThirdLevel?: string;
  status?: number;
  ruleActions?: RuleActionDto[];
}

export interface RuleActionDto {
  id?: number;
  actionName?: string;
  actionCondition?: number;
  actionSort?: number;
  actionType?: number | string;
  alertHandler?: string;
  alertHandleDue0?: number;
  alertHandleDue1?: number;
  alertHandleDue2?: number;
  alertHandleDue3?: number;
  alertHandlerType?: number | string;
  alertLevel?: number;
  alertMessage?: string;
  alertReviewDue0?: number;
  alertReviewDue1?: number;
  alertReviewDue2?: number;
  alertReviewDue3?: number;
  alertReviewer?: string;
  alertReviewerType?: number | string;
  ruleCode?: string;
  ruleId?: number;
  status?: number;
  index?: number;
}

export default class RuleServices {
  private readonly list_api = '/v1/ruledef/list';
  private readonly info_api = '/v1/ruledef/info';
  private readonly save_api = '/v1/ruledef/save-all';
  private readonly update_api = '/v1/ruledef/update-all';
  private readonly remove_api = '/v1/ruledef/delete';
  private readonly run_trail = '/v1/alerttrail/run-trail'; // 执行陪跑 startTime, endTime, ruleCode, ruleName
  private readonly alert_page = '/v1/alerttrail/alert-page'; // 陪跑预警
  private readonly trail_page = '/v1/alerttrail/trail-page'; // 陪跑页面
  private readonly trail_info_page = '/v1/alerttrail/info'; // 陪跑页面

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getEnableList(params?: object): Promise<any> {
    // 0-新建待提交，1-编辑待提交，2-新建已提交，3-编辑已提交，4-新建已审批，5-编辑已审批，6-新建已驳回，7-编辑已驳回
    return await this.getList({ ...params, status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async add(data: RuleDto) {
    const params = { ...data, ruleSort: '1', ruleCode: 'RULE_' + data.ruleCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: RuleDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  async runTrail(params?: object): Promise<any> {
    let res: any = await http.get(this.run_trail, { params: params });
    return res.header?.code == 200;
  }

  async trailList(params?: object): Promise<any> {
    let res: any = await http.get(this.trail_page, { params: params });
    return res.payload;
  }

  async trailAlertList(params?: object): Promise<any> {
    let res: any = await http.get(this.alert_page, { params: params });
    return res.payload;
  }

  async trailInfo(alertCode: string): Promise<any> {
    let res: any = await http.get(this.trail_info_page + '/' + alertCode);
    return res.payload;
  }
}
